import React from "react";

/**
 * Fretboard Atlas — Chord Position Explorer
 *
 * The actual app is a self-contained static HTML file at
 * /public/_tools/chord-atlas.html (own fonts, CSS, JS — intentionally
 * isolated so its CSS-variable theme doesn't fight the React app's
 * TailwindCSS reset). It lives under `_tools/` with a non-obvious filename
 * so a logged-out visitor typing `/chords.html` directly hits a 404 instead
 * of bypassing the RequireStudioAccess guard. The guard wraps the React
 * route at /chords; anyone who finds the iframe src in dev tools is
 * already past auth.
 */
export default function Chords() {
  return (
    <iframe
      title="Fretboard Atlas"
      src="/_tools/chord-atlas.html"
      data-testid="chords-iframe"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: "none",
        display: "block",
        background: "#0b0e1a",
      }}
    />
  );
}
